import Vue from 'vue'
import VueNestable from 'vue-nestable'
import VueNestableHandle from 'vue-nestable'

Vue.use(VueNestable)
Vue.use(VueNestableHandle)
